import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/index';
import { map } from 'rxjs/operators';
import { Constants } from '@app/shared-module/constants';
import { CommonService } from '@app/shared-module/common-service.service';
import { DoctorRegister, UpdateDoctorProfileRequest, CustomerRegister, Note } from '@app/shared-module/models';

@Injectable({
  providedIn: 'root'
})

export class DoctorService {

  constructor(
    private httpClient: HttpClient,
    private commonService: CommonService) { }

  isDoctorLoggedIn = false;


  registerDoctor(doctorPayload: DoctorRegister) {
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_REGISTER_API, doctorPayload);
  }

  login(emailId: string, password: string) {
    const login_payload = {
      userName: emailId,
      password
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_LOGIN_API, login_payload);
  }

  getDoctorDetails(docId: string) {

    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.DOCTOR_API + docId);
  }

  updateProfile(doctorPayload: UpdateDoctorProfileRequest) {
    return this.httpClient.put(Constants.MAIN_ENV_URL + Constants.DOCTOR_API, doctorPayload);
  }

  updateDoctorSettings(settingPayload: any) {
    return this.httpClient.put(Constants.MAIN_ENV_URL + Constants.DOCTOR_API + Constants.DOCTOR_SETTINGS_API, settingPayload);
  }

  fetchDoctorList() {
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.DOCTOR_API +
      Constants.DOCTOR_LIST_API);
  }

  changePassword(oldPassword: string, newPassword: string, doctorId: string) {
    const changePassword_payload = {
      newPassword,
      oldPassword,
      doctorId
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_CHANGE_PASSWORD_API, changePassword_payload);
  }

  forgotPassword(emailId: string) {
    const resetPassword_payload = {
      emailId
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.FORGOT_PASSWORD_API, resetPassword_payload);
  }

  registerCustomer(reqObj: CustomerRegister) {
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_REGISTER_CUSTOMER_API, reqObj);
  }

  fetchPets(searchType: string, searchValue: string) {
    const params = new HttpParams()
      .set(searchType, searchValue);
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.DOCTOR_FETCH_PETS_API, { params });
  }

  updateTodayCheckupPayment(reqObj: any) {
    const body = {
      amount: reqObj.amount,
      paymentMethod: reqObj.paymentMethod
    };
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_API + reqObj.doctorId + '/clinic/' + reqObj.clinicId
      + '/invoice/' + reqObj.invoiceId + '/payment', body);
  }

  requestOTP(mobile_number: string) {
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_OTP_GENERATE_API, { phone_no: mobile_number });
  }

  getBreeds(type: string = 'dog') {
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.DOCTOR_BREEDS_API + type);
  }

  getSpecies() {
    return this.httpClient.get(Constants.MAIN_ENV_URL + Constants.DOCTOR_PET_SPECIES_API);
  }

  verifyOTP(mobile_number: string, otp: string, otp_id: string) {
    const verify_otp_payload = {
      phone_no: mobile_number,
      otp,
      otp_id
    };
    return this.httpClient.put(Constants.MAIN_ENV_URL + Constants.DOCTOR_OTP_VERIFY_API, verify_otp_payload);
  }

  uploadDoctorProfileImage(docId: string, file: File) {
    const formData: FormData = new FormData();
    formData.append('profileImage', file, file.name);
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_UPLOAD_PROFILE_IMAGE_API + docId,
      formData);
  }

  uploadDoctorSignatureImage(docId: string, files: any) {
    const formData: FormData = new FormData();
    for (const file of files) {
      formData.append('digitalSignatureImage', file);
    }
    return this.httpClient.post(Constants.MAIN_ENV_URL + Constants.DOCTOR_UPLOAD_DIGITAL_SIGNATURE_API + docId,
      formData);
  }
}
